<template>
  <magic-ui-pop
    class="magic-ui-notify-pop"
    :config="popConfig"
  >
    <img
      v-if="msgList.length > 1"
      :class="['magic-ui-notify-pop-arrow-left',leftDisabled?'magic-ui-notify-pop-arrow-disabled':'']"
      src="//puui.qpic.cn/vshpic/0/0DC437CC95D5496C2ECE26FF3BE3ED471609391428/0"
      @click="leftHandler"
    >
    <div
      v-if="msgList[activeIndex]"
      class="magic-ui-notify-pop-inner"
    >
      <p class="magic-ui-notify-pop-title">
        {{ msgList[activeIndex].page_title || msgList[activeIndex].title || pageTitle }}
      </p>
      <p
        v-if="msgList[activeIndex].message"
        class="magic-ui-notify-pop-desc"
      >
        {{ msgList[activeIndex].message }}
      </p>
      <img
        v-if="msgList[activeIndex].image"
        class="magic-ui-notify-pop-img"
        :src="msgList[activeIndex].image"
      >
      <magic-ui-link
        v-if="msgList[activeIndex].btn_url"
        :config="{
          text: msgList[activeIndex].btn_text,
          href: msgList[activeIndex].btn_url,
        }"
      />
      <magic-ui-button
        v-else-if="msgList[activeIndex].btn_text"
        :config="{
          text: msgList[activeIndex].btn_text,
          handler: {
            needLogin: false,
            actions: [{
              fuc: () => app.closePop(popConfig.id),
            }],
          }
        }"
      />
    </div>
    <img
      v-if="msgList.length > 1"
      :class="['magic-ui-notify-pop-arrow-right',rightDisabled?'magic-ui-notify-pop-arrow-disabled':'']"
      src="//puui.qpic.cn/vshpic/0/BA9F138AE426D7B7C02FA3D2EECBAD621609391431/0"
      @click="rightHandler"
    >
  </magic-ui-pop>
</template>

<script>
import { getUrlParam } from '@tencent/magic-ui-util';
export default {
  name: 'MagicUiNotifyPop',

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    modId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      popConfig: {
        id: Math.ceil(Math.random() * 100000000),
        maskClose: false,
        closeButton: true,
        style: {
          height: 'auto',
        },
      },
      msgList: [],
      activeIndex: 0,
      pageTitle: '',
      notifySet: new Set(), // 其它有进页面弹窗的组件id集合
    };
  },

  computed: {
    leftDisabled() {
      return this.activeIndex <= 0;
    },

    rightDisabled() {
      return this.activeIndex >= this.msgList.length - 1;
    },
  },

  created() {
    this.notifySet.add(this.popConfig.id);
    this.findPageNotifyItems();
    this.addNotifyListener();
    this.getNotify();
  },

  methods: {
    leftHandler() {
      if (this.activeIndex <= 0) {
        return;
      }
      this.activeIndex -= 1;
    },

    rightHandler() {
      if (this.activeIndex >= this.msgList.length - 1) {
        return;
      }
      this.activeIndex += 1;
    },
    findPageNotifyItems() {
      const vm = this;
      function search(items) {
        if (Array.isArray(items)) {
          items.forEach((item) => {
            if (item.pageNotify && item.id) {
              vm.notifySet.add(item.id);
            }
            search(item.items);
            if (item.pop) {
              search(item.pop.items);
            }
          });
        }
      }
      search(this.app.pageConfig.items);
    },
    addNotifyListener() {
      // 其它组件弹窗完成后发送事件通知
      this.$bus.$on('magic:common:notify:pop', (fromCpt) => {
        const id = fromCpt.config?.id;
        if (id && this.notifySet.has(id)) {
          this.notifySet.delete(id);
        }
        // 其它弹窗已消耗且进页面提醒有数据
        if (this.notifySet.size === 0 && this.msgList.length) {
          this.app.openPop(this.popConfig.id);
        }
      });
    },
    async getNotify() {
      this.$bus.$on('magic:component:page:enter', async () => {
        const isPrepublish = getUrlParam('is_prepublish');
        const res = await this.app.request({
          url: '//activity.video.qq.com/fcgi-bin/asyn_activity',
          data: {
            type: 59,
            option: 1,
            act_id: this.app.id,
            module_id: this.modId,
            ...isPrepublish ? { is_prepublish: 1 } : {},
          },
        });

        if (res.ret !== 0) {
          return;
        }

        // eslint-disable-next-line
        if (res?.data?.page_title) {
          this.pageTitle = res.data.page_title;
        }

        if (res?.data?.list && Array.isArray(res.data.list) && res.data.list.length) {
          this.msgList = res.data.list;
          // 通知进页面提醒数据已经就绪
          this.$bus.$emit('magic:common:notify:pop', {
            config: {
              id: this.popConfig.id,
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
  @mixin ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding: 0 .12rem;
  }

  .magic-ui-notify-pop {
    .magic-ui-pop-content {
      padding: .18rem 0;
      width: 2.88rem;
      text-align: center;

      .magic-ui-button {
        display: block;
        text-align: center;
        font-size: .15rem;
        color: #fff;
        background: #f3593b;
        border-radius: .17rem;
        width: 2.25rem;
        margin: 0 auto;
        padding: .0825rem 0;
      }
    }

    &-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      min-height: 1.5rem;
    }

    &-arrow-left {
      position: absolute;
      top: 50%;
      left: -29px;
      width: .15rem;
      transform: translate3d(0, -50%, 0);
    }

    &-arrow-right {
      position: absolute;
      top: 50%;
      right: -29px;
      width: .15rem;
      transform: translate3d(0, -50%, 0);
    }

    &-arrow-disabled {
      opacity: 0.3;
    }

    &-img {
      max-width: 1.875rem;
      max-height: 3rem;
      margin: .11rem 0 .26rem;
    }

    &-title {
      @include ellipsis;
      color: #FF6022;
      font-size: .18rem;
      text-align: center;
      margin-bottom: .03rem;
    }

    &-desc {
      font-size: .15rem;
      text-align: center;
      color: #000028;
      padding: 0 .12rem;
    }
  }
</style>
